// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2361":"da2cc301bd0ac13d","2842":"c00d4cf5629adcdf"}[chunkId] + ".js";
};